import { getEvnVariable, isDevelopment } from "@/shared/utils/assembly";

// use flag, bcz it's often case when Book.site accidentally becomes Next application.
const IS_BOOK_SITE = true;

export const isLandingApp = () => isDevelopment() ? IS_BOOK_SITE : getEvnVariable(
  "REACT_APP_IS_LANDING", process.env.REACT_APP_IS_LANDING
) === "true";

export const getLandingMapOriginToBookId = () => {
  const value = getEvnVariable(
    "REACT_APP_LANDING_MAP_HOST_TO_BOOK_ID",
    process.env.REACT_APP_LANDING_MAP_HOST_TO_BOOK_ID,
    "{}");

  try {
    return JSON.parse(value);
  } catch (e) {
    console.log("[LANDING] Error parse REACT_APP_LANDING_MAP_HOST_TO_BOOK_ID", { value });
    return {};
  }
};